export interface Person {
  personId: string;
  firstName: string;
  lastName: string;
  hrRef: number;
  isExternal: boolean;
  company: string;
  email: string;
  phone: string;
}
